/** Minimal shape the resume predicate reads. Both ReasoningChat's local
 * `Chain` and the proposals/reasoning `ReasoningChain` satisfy it. */
export interface ProcessingChain {
  task_id?: string | null;
  processing_status?: string;
  status?: string;
  /** The user prompt that started this chain, when the caller's chain type
   * carries it. Read on resume to rehydrate the in-flight message. */
  user_message?: string;
}

/**
 * Find the chain that is actively processing, if any. Used to restore
 * polling state — and the in-flight user prompt — after page refresh or
 * navigation.
 */
export function findActiveProcessingChain(
  chains: ProcessingChain[]
): ProcessingChain | null {
  if (!chains || chains.length === 0) {
    return null;
  }
  const processingChain = chains.find(chain => {
    if (!chain.task_id) {
      return false;
    }
    const procStatus = chain.processing_status;
    if (procStatus === 'queued' || procStatus === 'processing') {
      return true;
    }
    if (procStatus !== undefined && procStatus !== null) {
      return false;
    }
    const { status } = chain;
    if (status === 'active' || status === 'processing') {
      return true;
    }
    return false;
  });
  return processingChain ?? null;
}

/**
 * Check if any chain is actively processing and needs polling resumed.
 * Used to restore polling state after page refresh or navigation.
 */
export function findActiveProcessingTask(
  chains: ProcessingChain[]
): string | null {
  return findActiveProcessingChain(chains)?.task_id ?? null;
}
